// Onboarding page with multi-step wizard
import { useEffect } from 'react'
import { useAuthContext } from '@/contexts/auth-context'
import { useNavigate } from 'react-router-dom'
import { OnboardingWizard } from '@/components/onboarding/onboarding-wizard'

export default function OnboardingPage() {
  const { user, isLoaded } = useAuthContext()
  const navigate = useNavigate()

  useEffect(() => {
    // If not loaded or no user, redirect to login
    if (isLoaded && !user) {
      navigate('/login')
    }
  }, [user, isLoaded, navigate])

  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (!user) {
    return null
  }

  const handleComplete = () => {
    navigate('/dashboard')
  }

  const handleSkip = () => {
    navigate('/dashboard')
  }

  return <OnboardingWizard onComplete={handleComplete} onSkip={handleSkip} />
} 